module.exports = __webpack_public_path__ + "img/25.f41b5e68.png";